/**
 * Centralized DataTable Theme Styles for Rutex Backoffice
 * Guarantees typography (Montserrat), accessibility, dark/light contrast,
 * and unified loading/empty states across all DataTables.
 * 
 * @param {boolean} isDark - Active theme indicator
 * @returns {object} react-data-table-component customStyles object
 */
export const getDataTableStyles = (isDark = false) => ({
  table: {
    style: {
      backgroundColor: isDark ? '#161e38' : '#ffffff',
      borderCollapse: 'collapse',
      border: 'none',
      width: '100%',
      minWidth: '100%',
    },
  },
  tableWrapper: {
    style: {
      backgroundColor: isDark ? '#161e38' : '#ffffff',
      overflowX: 'auto',
      overflowY: 'hidden',
      WebkitOverflowScrolling: 'touch',
      width: '100%',
    },
  },
  responsiveWrapper: {
    style: {
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      width: '100%',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#183eeb',
      minHeight: '48px',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      backgroundColor: '#183eeb',
      color: '#ffffff',
      fontWeight: '700',
      textTransform: 'uppercase',
      paddingLeft: '14px',
      paddingRight: '14px',
      fontSize: '0.78rem',
      letterSpacing: '0.5px',
      border: 'none',
      minWidth: '0px',
      overflow: 'hidden',
    },
  },
  rows: {
    style: {
      minHeight: '64px',
      backgroundColor: isDark ? '#161e38' : '#ffffff',
      color: isDark ? '#ffffff' : '#010028',
      paddingTop: '6px',
      paddingBottom: '6px',
      borderBottomColor: isDark ? '#233052' : '#e2e8f0',
      '&:hover': {
        backgroundColor: isDark ? '#1e2a4a' : 'rgba(24, 62, 235, 0.04)',
        transition: 'background-color 0.15s ease',
      },
    },
  },
  cells: {
    style: {
      paddingLeft: '14px',
      paddingRight: '14px',
      border: 'none',
      color: isDark ? '#ffffff' : '#010028',
      minWidth: '0px',
      overflow: 'hidden',
    },
  },
  progress: {
    style: {
      backgroundColor: isDark ? '#161e38' : '#ffffff',
      color: isDark ? '#818cf8' : '#183eeb',
      minHeight: '220px',
    },
  },
  pagination: {
    style: {
      backgroundColor: isDark ? '#161e38' : '#ffffff',
      color: isDark ? '#ffffff' : '#010028',
      borderTop: isDark ? '1px solid #233052' : '1px solid #e2e8f0',
    },
    pageButtonsStyle: {
      borderRadius: '50%',
      height: '34px',
      width: '34px',
      padding: '6px',
      margin: '0 2px',
      cursor: 'pointer',
      transition: '0.2s',
      color: isDark ? '#cbd5e1' : '#495057',
      fill: isDark ? '#cbd5e1' : '#495057',
      backgroundColor: 'transparent',
      '&:disabled': {
        cursor: 'unset',
        color: isDark ? '#475569' : '#ced4da',
        fill: isDark ? '#475569' : '#ced4da',
      },
      '&:hover:not(:disabled)': {
        backgroundColor: isDark ? '#233052' : '#e9ecef',
      },
      '&:focus': {
        outline: 'none',
        backgroundColor: isDark ? '#233052' : '#e9ecef',
      },
    },
  },
  noData: {
    style: {
      backgroundColor: isDark ? '#161e38' : '#ffffff',
      color: isDark ? '#94a3b8' : '#64748b',
      minHeight: '180px',
    },
  },
});

export default getDataTableStyles;
